import React, { useEffect } from "react";
import companyLogo from "../../assets/FullLogo_Transparent_NoBuffer (3).png";
import defaultDriverPhoto from "../../assets/3d-illustration-cartoon-character-hoodie-cap.jpg";
import { useSelector, useDispatch } from "react-redux";
import { driverSelector, fetchOnedriver } from "../../api/driver";

export default function DriverIDCard() {
  const dispatch = useDispatch();
  const { current_driver } = useSelector(driverSelector);

  const driver_id_ = localStorage.getItem("Driver"); // fixed key
  console.log("Driver ID from localStorage:", driver_id_);

  useEffect(() => {
    if (driver_id_) {
      dispatch(fetchOnedriver(driver_id_));
    } else {
      console.warn("No driver ID found in localStorage.");
    }
  }, [dispatch, driver_id_]);

  return React.createElement(
    "div",
    {
      className:
        "max-w-sm mx-auto mt-36 bg-white shadow-lg rounded-xl p-6 border border-gray-200 mb-18",
    },
    React.createElement(
      "div",
      { className: "flex justify-between items-center mb-4" },
      React.createElement("img", {
        src: companyLogo,
        alt: "Company Logo",
        className: "h-10",
      }),
      React.createElement(
        "h2",
        { className: "text-xl font-bold text-gray-800" },
        "Driver ID Card"
      )
    ),
    React.createElement(
      "div",
      { className: "flex justify-center mb-4" },
      React.createElement("img", {
        src: current_driver?.Driver_photo_link || defaultDriverPhoto,
        alt: "Driver",
        className:
          "w-24 h-24 rounded-full border-4 border-blue-200 object-cover",
      })
    ),
    React.createElement(
      "div",
      { className: "text-gray-700 space-y-2 text-sm" },
      React.createElement(
        "p",
        null,
        React.createElement("span", { className: "font-semibold" }, "Name: "),
        current_driver?.name || "N/A"
      ),
      React.createElement(
        "p",
        null,
        React.createElement("span", { className: "font-semibold" }, "Phone Number: "),
        current_driver?.phone_number || "N/A"
      ),
      React.createElement(
        "p",
        null,
        React.createElement("span", { className: "font-semibold" }, "Email ID: "),
        current_driver?.email || "N/A"
      ),
      React.createElement(
        "p",
        null,
        React.createElement("span", { className: "font-semibold" }, "Address: "),
        current_driver?.Location || "N/A"
      ),
      React.createElement(
        "p",
        null,
        React.createElement(
          "span",
          { className: "font-semibold" },
          "License No: "
        ),
        current_driver?.Driver_licence_number || "N/A"
      ),
      React.createElement(
        "p",
        null,
        React.createElement(
          "span",
          { className: "font-semibold" },
          "Number of Vehicles: "
        ),
        current_driver?.vehicleId?.length || 0
      )
    )
  );
}
